const state = {
  privacy_policy: [],
  privacy_policy_id: [],
};

export default state;
